import { TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import { IMaskMixin } from "react-imask";

const MaskInput = IMaskMixin(({ ...props }: any) => {
  return <TextField {...props} />;
});

const onChangeValue = (value: any, onChange: any) => {
  onChange && onChange(value);
};

const MaskField: React.FC<any> = ({ ...props }) => {
  return <Controller {...props} render={({ field: { name , value ,  onChange , ref } }) => <MaskInput name={name} value={value} inputRef={ref} onAccept={(value, mask)=>onChangeValue(value , onChange)} type="text"  {...props} />} />;
};

export default MaskField;
